module.exports = __webpack_public_path__ + "img/Frame 1143seven.06fda8c6.png";